import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { MATCH_LOCALE_STORAGE_KEY, normalizeMatchLocale } from './matchLocale';
import { matchingResources } from './matchingResources';

if (!i18n.isInitialized) {
  void i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources: matchingResources,
      defaultNS: 'matching',
      fallbackLng: 'en',
      supportedLngs: ['en', 'es'],
      nonExplicitSupportedLngs: true,
      load: 'languageOnly',
      interpolation: { escapeValue: false },
      react: { useSuspense: false },
      detection: {
        order: ['localStorage', 'navigator'],
        lookupLocalStorage: MATCH_LOCALE_STORAGE_KEY,
        caches: ['localStorage'],
        convertDetectedLanguage: normalizeMatchLocale,
      },
    });
}

export { i18n };
